import { withBreadcrumb } from '#lib/utils/kit.js';
import type { PageLoad } from './$types';

export const load = withBreadcrumb('System') satisfies PageLoad;
